<!-- <p class="editMat" *ngIf="isEdit">Edit Matter</p>
<p class="editMat" *ngIf="!isEdit">Create Matter</p> -->

<div class="hole">
<form class="formAl" [formGroup]="generalForm" (ngSubmit)="onSubmit()">
  <span class="matlabel">Matter Info</span>
  <div class="row main stepitem ">
    
    <div class="col-xs-12 col-sm-12 col-md-6">
      <!-- Form Component -->
      <!-- left row card 1 layout -->

      <div class="row containerbox containerboxone ">
        <div class="col-sm-12">
          <div class="container">

            <!-- input field  -->
            <div class="form-group">
              <label for="title" class="fontbold">Case Title <span class="mandate">*</span>
              </label>
              <input formControlName="title" (input)="restricttextSpace($event)" maxlength="250" type="text" class="form-control textbox" id="title" name="title"
                [ngClass]="{'is-invalid':submitted && f.title.errors}">
              <div *ngIf="submitted && f.title.errors" class="invalid-feedback">
                <div *ngIf="f.title.errors.required">Case Title is required</div>
                <div *ngIf="f.title.errors.pattern"> Restricted Space at First Position </div>
              </div>
            </div>

            <!-- input field  -->
            <!-- <div class="form-group">
              <label for="title" class="fontbold">Matter Number <span class="mandate">*</span>
              </label>
              <input type="text" (input)="restricttextSpace($event)" maxlength="30" class="form-control textbox" id="matterNumber" name="matterNumber"
                formControlName="matterNumber" [ngClass]="{'is-invalid':submitted && f.matterNumber.errors}">
              <div *ngIf="submitted && f.matterNumber.errors" class="invalid-feedback">
                <div *ngIf="f.matterNumber.errors.required">MatterNumber is required</div>
                <div *ngIf="f.matterNumber.errors.pattern"> Restricted Space at First Position </div>
              </div>
            </div> -->

            <div class="form-group">
              <label class="fontbold">Matter Number <span class="mandate">*</span></label>
              <div class="input-with-icon">
                <input type="text" class="form-control textbox" maxlength="30" id="matterNumber" formControlName="matterNumber"
                  (input)="restricttextSpace($event)" [ngClass]="{'is-invalid': submitted && f.matterNumber.errors,'disabled-opacity': true}" readonly/>
                <i class="fa fa-info-circle info-icon" matTooltip="Automatically generated by the system" aria-hidden="true"></i>
              </div>
            
              <div *ngIf="submitted && f.matterNumber.errors" class="invalid-feedback">
                <div *ngIf="f.matterNumber.errors.required">Matter Number is required</div>
              </div>
            </div>

            <!-- additional details link -->
            <p *ngIf="!showMore" class="addInfo" (click)="showMore = !showMore">Additional Details</p>
  
            <!-- Start & Close Date-->        
            <div class="form-group" *ngIf="showMore">
              <label class="fontbold">Start Date </label>
            
              <div class="custom-date-wrapper">
                <input #startDp="bsDatepicker" bsDatepicker [bsConfig]="datePickerConfig" formControlName="startdate"
                  name="startdate" placeholder="Select Date" class="custom-input dpc" readonly 
                  (keydown)="$event.preventDefault()" (paste)="$event.preventDefault()" (keypress)="$event.preventDefault()"
                  (bsValueChange)="addEventStart('change', $event)" />
            
                <button class="icon-btn" type="button" (click)="startDp.show(); $event.stopPropagation()">
                  <img src="assets/img/cal-icon.svg" alt="calendar" />
                </button>
              </div>
            </div>
            
            <div class="form-group" *ngIf="showMore">
              <label class="fontbold">Close Date </label>
            
              <div class="custom-date-wrapper">
                <input #closeDp="bsDatepicker" bsDatepicker [bsConfig]="datePickerConfig" formControlName="closedate"
                  name="closedate" placeholder="Select Date" class="custom-input dpc" readonly [minDate]="minDateEnd"
                  (keydown)="$event.preventDefault()" (paste)="$event.preventDefault()" (keypress)="$event.preventDefault()"
                  (bsValueChange)="addEvent('change', $event)" />
            
                <button class="icon-btn" type="button" (click)="closeDp.show(); $event.stopPropagation()">
                  <img src="assets/img/cal-icon.svg" alt="calendar" />
                </button>
              </div>
            </div>

            <!-- text area -->
            <div class="form-group" *ngIf="showMore">
              <label for="filling date" class="fontbold">Description</label>
              <textarea rows="4" (input)="restricttextSpace($event)" cols="50" class="form-control textbox" formControlName="description"
                name="description" [ngClass]="{'is-invalid':submitted && f.description.errors}"
                maxlength="300"></textarea>
              <!-- <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
                <div *ngIf="f.description.errors.required">Description is required</div>
              </div> -->
              <div class="count-div">
                <div class="count-text" *ngIf="f.description">{{f.description.value.length}}/300</div>
              </div>
            </div>

            <!-- <div class="form-group">
              <label for="tags" class="fontbold">Matter Tags</label>
              <input type="text" (input)="restricttextSpace($event)" class="form-control textbox" id="tags" name="tags" placeholder="Type to add" formControlName="tags">
            </div> -->
            <add-tag [editTagList]="editeMatterInfo?.tags || data?.tags" *ngIf="showMore"
                (childButtonEvent)="receiveTagMsgHandler($event)"></add-tag>
          </div>
          <p *ngIf="showMore" class="addInfo" (click)="showMore = !showMore">Show Less Details</p>
        </div>
      </div>
      <!-- ends here -->
    </div>
    <div class="col-xs-12 col-sm-12 col-md-6">
      <!-- component right side -->

      <div class="row containerbox formcontainer">
        <div class="col-sm-12">
          <div class="container">
            <!-- input field  -->
            <div class="form-group">
              <label for="title" class="fontbold">Matter Type </label>
              <input type="text" (input)="restricttextSpace($event)" class="form-control textbox" id="matterType" name="matterType"
                formControlName="matterType" [ngClass]="{'is-invalid':submitted && f.matterType.errors}">
              <div *ngIf="submitted && f.matterType.errors" class="invalid-feedback">
                <div *ngIf="f.matterType.errors.required">MatterType is required</div>
              </div>
            </div>

            
            <!-- created date of field -->
            <!-- <div class="form-group">
              <label class="fontbold">Created Date </label>
              <div class="custom-date-wrapper">
                <input class="custom-input" [matDatepicker]="picker2" formControlName="created_date" readonly name="created_date" (click)="picker2.open()" placeholder="Select Date" />
                <button class="icon-btn" type="button" (click)="picker2.open()">
                  <mat-icon>calendar_today</mat-icon>
                </button>
                <mat-datepicker #picker2></mat-datepicker>
              </div>
             </div> -->

            <div class="form-group">
              <label class="fontbold">Created Date </label>
              <div class="custom-date-wrapper">
                <input #createdDp="bsDatepicker" bsDatepicker [bsConfig]="createdatePickerConfig" formControlName="created_date"
                  class="custom-input dpc" readonly (keydown)="$event.preventDefault()" (paste)="$event.preventDefault()" (keypress)="$event.preventDefault()"  />
                <button class="icon-btn" type="button" (click)="createdDp.show(); $event.stopPropagation()">
                  <img src="assets/img/cal-icon.svg" alt="calendar" />
                </button>
              </div>
            </div>

            <!-- input switch button -->
            <div class="row" *ngIf="showMore">
              <div class="col-sm-7">
                <p class="prioritytxt fontbold pad">Priority</p>
              </div>
              <div class="col-sm-5">
                <p class="prioritytxt fontbold pad">Status</p>
              </div>
            </div>
            <div class="row" *ngIf="showMore">
              <div class="col-sm-7">
                <ul class="nav nav-pills mb-3 btnaction" id="pills-tab" role="tablist">
                  <li class="nav-item" (click)="getPriority('High')">
                    <button  id="High"   name="priority"  [ngClass]="{'active': selectedPriority === 'High'}" class="selectprior optionhigh"
                      id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab"
                      aria-controls="pills-home" aria-selected="true">High</button>
                  </li>
                  <li class="nav-item" (click)="getPriority('Medium')">
                    <button  id="Medium" [ngClass]="{'active': selectedPriority === 'Medium'}" name="priority"  class="selectprior optionaling"
                      id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button"
                      role="tab" aria-controls="pills-profile" aria-selected="false">Medium</button>
                  </li>
                  <li class="nav-item" (click)="getPriority('Low')">
                    <button id="Low"  [ngClass]="{'active': selectedPriority === 'Low'}" name="priority"  class=" selectprior optionlow"
                      id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button"
                      role="tab" aria-controls="pills-contact" aria-selected="false">Low</button>
                  </li>
                </ul>
              </div>
              <div class="col-sm-5">
                <ul class="nav nav-pills mb-3 btnaction" id="pills-tab" role="tablist">
                  <li class="nav-item" (click)="getStatus('Active')">
                    <button class="selectprior optionhigh" [ngClass]="{'active': selectedStatus === 'Active'}" id="pills-home-tab" data-bs-toggle="pill"
                      data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home"
                      aria-selected="true">Active</button>
                  </li>
                  <li class="nav-item" (click)="getStatus('Pending')">
                    <button class="selectprior optionaling pend" [ngClass]="{'active': selectedStatus === 'Pending'}" id="pills-profile-tab" data-bs-toggle="pill"
                      data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile"
                      aria-selected="false">Pending</button>
                  </li>
                </ul>
              </div>
            </div>
            <!-- end advocate -->
            <!-- pagination -->

          </div>
          <!-- ends here -->
        </div>
      </div>

    </div>
    <div class="btnbox">
      <!-- <button type="button" class="btn btn-default btncancel btnrightitem" (click)="OnCancel()">Save for Later</button> -->
      <!-- <button type="button" class="btn btn-default btncancel" (click)="OnCancel()">
        {{ generalForm.invalid ? 'Cancel' : 'Save for Later' }}
      </button> -->

      <button type="button" class="btn btn-default btncancel orgc" (click)="OnCancel()">Cancel</button>
      <button type="button" class="btn btn-default btncancel" *ngIf="!generalForm.invalid" (click)="OnSaveLater()">Save for Later</button>


      <button type="submit" class="btn btn-primary btnsave savecls infoBtn" [disabled]="generalForm.invalid">
        <span *ngIf="product !== 'corporate'">Save & Next</span>
        <span *ngIf="!isEdit && product === 'corporate'">Save</span>
        <!-- <span *ngIf="isEdit">Save</span> -->
      </button>
    </div>
  </div>
  <!-- grid ends here -->
</form>
</div>

<ngx-spinner  size="medium" type="ball-clip-rotate"></ngx-spinner>